import {
  ResforNif,
  ResforData,
  ResforRepositoryError,
  ResforNotFoundError,
  ResforNifNotFoundError,
  ResforCommunicationYearNotValidError,
  ResforFactory
} from '@/Domain/Resfor'
import { ApiClient, Api500Error, Api404Error, Api405Error, Api409Error } from '@/Domain/ApiClient'
import { AxiosResforResponse } from './AxiosResforResponse'

export class AxiosResforRepository {
  private _apiClient: ApiClient
  private _resforFactory: ResforFactory<AxiosResforResponse>

  constructor (apiClient: ApiClient, resforFactory: ResforFactory<AxiosResforResponse>) {
    this._apiClient = apiClient
    this._resforFactory = resforFactory
  }

  async byNif (resforNif: ResforNif): Promise<ResforData> {
    try {
      const url = '/sobree/api/resfor/' + resforNif.codeId()
      const response = await this._apiClient.makeGetRequest(url, {})
      const resforData = this._resforFactory.makeResforData(response.data.data)
      return resforData
    } catch (error) {
      if (error instanceof Api500Error) {
        return Promise.reject(new ResforRepositoryError(error.message))
      }
      if (error instanceof Api404Error) {
        return Promise.reject(new ResforNotFoundError(error.message))
      }
      if (error instanceof Api405Error) {
        return Promise.reject(new ResforNifNotFoundError(error.message))
      }
      if (error instanceof Api409Error) {
        return Promise.reject(new ResforCommunicationYearNotValidError(error.message))
      }
      return Promise.reject(error)
    }
  }
}
